import { useState, ChangeEvent } from "react"

export const useFormulario = <T extends Object>(objetoInicial: T) => {
    const [objeto, setObjeto] = useState(objetoInicial);

    // Campos cuyo valor nunca se sanitiza (contraseñas): no se reflejan en el
    // DOM (sin riesgo de XSS) y "&" es uno de los caracteres especiales que el
    // backend exige, así que sanitizarlos corrompía el valor en cada tecla.
    // Se identifica por "name" y no por el "type" del input porque CampoTexto
    // cambia el type a "text" cuando el usuario activa "mostrar contraseña".
    const CAMPOS_SIN_SANITIZAR = /clave|password|contrasen/i;

    const dobleEnlace = ({ target }: ChangeEvent<any>) => {
        const { name, value } = target;
        // Solo se sanitiza texto. Los <select> de MUI pueden entregar valores
        // numéricos (ej. sexoBiológico = 1 | 2) y llamar .replace() sobre un
        // número rompía la página con "value.replace is not a function".
        const sanitizedValue = CAMPOS_SIN_SANITIZAR.test(name) || typeof value !== "string"
            ? value
            : value.replace(/[<>"'&]/g, '');
        setObjeto({ ...objeto, [name]: sanitizedValue });
    }

    return {
        objeto,
        dobleEnlace,
        ...objeto
    }
}